import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import ViewClaimM from "./M/ViewClaimM";
import { SysConfig } from "__SYSDefault/Config";
import ViewClaimW from "./W/ViewClaimW";

/**
 * @augments {Component<Props, State>}
 */
class ViewClaim extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ViewClaim.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <ViewClaimM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <ViewClaimW {...this.props} />
    });
  }

}

export default observer(ViewClaim);
